import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Delightful state management with hooks and Constate",
  "description": "",
  "published": "2019-01-16T00:00:00.000Z",
  "redirect_from": ["/blog/delightful-state-management-with-hooks-and-constate/swizec/8876"],
  "categories": "Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1547664644055.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wanna get a room full of React engineers talking? Mention state management.`}</p>
    <p>{`Everyone has their favorite library. The Redux camp loves their actions and reducers and sagas and whatnot. The MobX camp loves observers and actions and overwritten object defaults and magic.`}</p>
    <p>{`Both say their way is simplest. Both hide many footguns.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/thekitze/status/1085062217312153600"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "126.45739910313902%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'505\\'%20viewBox=\\'0%200%20400%20505\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2022c-3%202-5%204-6%208-2%205-1%206%203%205%203-1%203-2%203-5%200-4%200-5%202%208%201%203%201%203-2%204-6%201%200%207%208%207%206%200%2014-7%2014-12l-2%201c-1%203-4%204-4%201h-3c-2-2-6-2-6%200h-1c-2-1-3-10-1-8l1%202%201%202%201-1c-1-1%200-2%201-2l1-1-3-1c-3%200-2-2%202-3%203%200%207%201%207%203l-1%201c-2%200-3%202-3%204l2%201%201-1h1c1%201%203-6%203-9-1-5-14-8-19-4m137%2080c-2%202-2%207%200%209%203%204%209%201%209-4%200-6-6-9-9-5m163%205v6h9v-5c0-7-1-8-6-8h-3v7M28%20165c-4%202-4%203-4%2091l1%2084h65a827%20827%200%200086-2l17%201v-25l-4-1c-22-3-40-21-44-42l-1-24%201-18%205-1h6v22l1%2022%203%206c4%2010%2010%2015%2019%2020l7%204h13c13%200%2014-1%2020-4%208-4%2016-11%2020-19%202-5%203-6%203-28l1-22%205-1h6v48l-4%207c-8%2017-24%2028-41%2031h-4v12l1%2012%2018%201h84l66%201V168l-3-2c-2-2-3-2-74-2-67%200-71%200-71%202l2%206c2%204%202%2010%202%2052%200%2047-1%2048-3%2052-5%2010-13%2013-30%2013-15-1-21-4-26-14a632%20632%200%20012-111l-145%201m24%20186c-2%202%200%204%205%205l6-1h6c2-1%205%201%203%203h2c2-1%203-7%200-7-1-1-2%200-3%201%200%201-1%201-2-1h-4c-1%202-2%202-3%200-1-1-7%201-7%202v1l-1-2%201-1%202-1c0-2-4-1-5%201m119%2094c-4%204-5%208-2%2011%205%205%2013%203%2013-4%200-6-7-10-11-7m18%201c-4%203-4%208-1%2011s8%203%2011-1c2-2%203-6%201-6l-1-1c1-1-3-5-6-5l-4%202m36%200l-3%205c-1%207%207%2011%2013%206%206-7-3-17-10-11m36%200c-5%204-2%2013%204%2013%204%200%207-1%208-5%202-7-6-13-12-8m20-1c-3%200-5%206-4%208%201%206%209%208%2013%203%202-3%202-4%201-7-2-4-6-6-10-4m-146%203c0%201%200%202-1%201-1-4-3-1-3%203%200%205%209%209%2012%206l1-9-1-1c0-3-2-3-4-1s-2%202-2%200c0-3-2-2-2%201m18%201v5l-1-4c-1-4-2-2-2%203s8%208%2011%204c5-5%202-12-4-12h-4v4m90-2c-3%203-2%2011%202%2011%209%201%2012-5%207-11-2-3-7-3-9%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/70363d898731ce182a0673546c9f872a/ca0a1/techletter.app-screenshot-1547664644055.webp 223w", "/static/70363d898731ce182a0673546c9f872a/75680/techletter.app-screenshot-1547664644055.webp 445w", "/static/70363d898731ce182a0673546c9f872a/d3be9/techletter.app-screenshot-1547664644055.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/70363d898731ce182a0673546c9f872a/e92b6/techletter.app-screenshot-1547664644055.png 223w", "/static/70363d898731ce182a0673546c9f872a/e66bf/techletter.app-screenshot-1547664644055.png 445w", "/static/70363d898731ce182a0673546c9f872a/e85cb/techletter.app-screenshot-1547664644055.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/70363d898731ce182a0673546c9f872a/e85cb/techletter.app-screenshot-1547664644055.png",
                "alt": "https://twitter.com/thekitze/status/1085062217312153600",
                "title": "https://twitter.com/thekitze/status/1085062217312153600",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/thekitze/status/1085062217312153600`}</figcaption>{`
  `}</figure></a></p>
    <p>{`It's 2019. You probably don't need a state management library.`}</p>
    <p>{`🤔`}</p>
    <p>{`Got a simple app? A handful of properties shared between a couple components?`}</p>
    <p>{`Use local state.`}</p>
    <h2 {...{
      "id": "local-state-is-your-best-friend"
    }}>{`Local state is your best friend`}</h2>
    <p>{`Contrary to popular belief, you don't need complex state management to build a login form with two fields. Something like this will do 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class Field extends React.Component {
    state = {
        value: "",
        error: ""
    }
    onChange = event => this.setState({
        value: event.target.value
    }, this.validate);
    validate = () => {
        const { value } = this.state;
        if (!someValidationRequirement(value)) {
            this.setState({
                error: "My lovely error"
            })
        }
    }
    render() {
        const { value, error } = this.state;
        return (
            <>
                <input value={value} onchange={this.onChange}>
                {error}

        )
    }
}
`}</code></pre>
    <p>{`That's a field with a `}<inlineCode parentName="p">{`value`}</inlineCode>{` and `}<inlineCode parentName="p">{`error`}</inlineCode>{` state. Typing triggers the `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` handler and updates state. This triggers a re-render and users can see what they're typing.`}</p>
    <p>{`Field validation triggers after state update, checks against some external function, and sets the error. You could use the presence of this error to make your field red or whatever.`}</p>
    <p>{`A login form can reuse this field twice.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class Login extends React.Component {
  render() {
    return (
      <div>
        <field>
          <field></field>
        </field>
      </div>
    );
  }
}
`}</code></pre>
    <h2 {...{
      "id": "hoisted-state-is-best-state"
    }}>{`Hoisted state is best state`}</h2>
    <p><em parentName="p">{`"But Swizec, how will my form get those values? How will joint validation work?"`}</em></p>
    <p>{`Right. It's best to hoist your state into the form. You've just discovered that the `}<em parentName="p">{`form`}</em>{` cares about this state, not the fields.`}</p>
    <p>{`The magic of asking questions to avoid building things you don't need.`}</p>
    <p>{`Something like this, then 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const Field = ({ onChange, value, error }) => (
    <>
        <input value={value} onchange={onChange}>
        {error}

)
class Login extends React.Component {
    state = {
        user: {
            value: "",
            error: ""
        },
        pass: {
            value: "",
            error: ""
        },
        error: ""
    }
    validate = () => {
        const { user, pass } = this.state;
        if (!someValidation(user.value) || !someValidation(pass.value)) {
            this.setState({
                error: "A lovely form error"
            });
        }
    }
    onChangeUser = event => this.setState({
        user: {
            value: event.target.value
        }
    }, () => {
        if (!someValidation(event.target.value)) {
            this.setState({
                user: {
                    value: event.target.value,
                    error: "A user error oh my"
                }
            })
        }
    }
    onChangePass = event => this.setState({
        pass: {
            value: event.target.value
        }
    }, () => {
        if (!someValidation(event.target.value)) {
            this.setState({
                pass: {
                    value: event.target.value,
                    error: "A password error oh my"
                }
            })
        }
    }
    render() {
        const { user, pass, error } = this.state;
        return (
            <form>
                <field value={user.value} error={user.error} onchange={this.onChangeUser}>
                <field value={pass.value} error={pass.error} onchange={this.onChangePass}>
                {error}

        )
    }
}
</field></field></form>
`}</code></pre>
    <p>{`Pretty repetitive, I agree. But it works and you didn't need no library.`}</p>
    <p>{`Same concept as before except we moved all the `}<inlineCode parentName="p">{`Field`}</inlineCode>{` machinery into our form. Duplicated it twice for two fields and turned fields into fully managed components.`}</p>
    <p>{`You can just imagine how this code explodes in complexity the more fields you add.`}</p>
    <h2 {...{
      "id": "context-to-the-rescue"
    }}>{`Context to the rescue`}</h2>
    <p>{`We can think of forms as sections of our app. Contexts.`}</p>
    <p>{`The modern context API makes it pretty painless to create ad-hoc contexts that share state among several components. We can use that to move some logic back into our fields.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const FormContext = React.createContext();
`}</code></pre>
    <p>{`This creates a `}<inlineCode parentName="p">{`FormContext`}</inlineCode>{` We're using it in a contrived way and I'll explain why.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class Field extends React.Component {
    state = {
        value: this.props.value,
        error: ""
    }
    onChange = event => this.setState({
        value: event.target.value
    }, this.validate);
    validate = () => {
        const { value } = this.state;
        if (!someValidationRequirement(value)) {
            this.setState({
                error: "My lovely error"
            })
        } else {
            this.props.returnValue(this.state.value)
        }
    }
    render() {
        const { value, error } = this.state;
        return (
            <>
                <input value={value} onchange={this.onChange}>
                {error}

        )
    }
}
const ContextField = ({ name }) => (
    <formcontext class="consumer">
        {(state) => (
            <field value={name} returnvalue="{value" ==""> state.onChange(value, name) />
        )}

)<br>
</field></formcontext>
`}</code></pre>
    <p>{`Same smart form field as we had before. It takes care of validation and temp value keeping internally. When it's happy it returns the verified value to the form with the `}<inlineCode parentName="p">{`this.props.returnValue`}</inlineCode>{` method.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`returnValue`}</inlineCode>{` method and initial field value come from context. That's where the `}<inlineCode parentName="p">{`ContextField`}</inlineCode>{` component comes in.`}</p>
    <p>{`With a shared context we can render these fields as deep inside our tree as we want, a different file even, and they can all talk to our Login form.`}</p>
    <p>{`The Login form then looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class Login extends React.Component {
  state = {
    user: "",
    pass: "",
    error: "",
    onChange: (value, field) =>
      this.setState(
        {
          [field]: value,
        },
        this.validate
      ),
  };
  validate = () => {
    const { user, pass } = this.state;
    if (!someValidation(user) || !someValidation(pass)) {
      this.setState({
        error: "A lovely form error",
      });
    }
  };
  render() {
    const { error } = this.state;
    return (
      <formcontext class="provider" value={this.state}>
        <contextfield name="user">
          <contextfield name="pass">{error}</contextfield>
        </contextfield>
      </formcontext>
    );
  }
}
`}</code></pre>
    <p>{`We now have a form that keeps valid `}<inlineCode parentName="p">{`user`}</inlineCode>{` and `}<inlineCode parentName="p">{`pass`}</inlineCode>{` state, provides a change method via context, and renders fields by just giving them a name.`}</p>
    <p>{`With this approach you can add as many fields as you want with very little overhead. You could make further improvements by thinking up types of fields, passing validations with props etc.`}</p>
    <p>{`But there's still a lot of code to look at.`}</p>
    <h2 {...{
      "id": "state-with-hooks-oh-my-️"
    }}>{`State with hooks, oh my ❤️`}</h2>
    <p>{`That's where hooks come in. Hooks make stuff like this a breeze.`}</p>
    <p>{`Check out that same field implemented with React hooks 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const Field = ({ value, returnValue }) => {
    const [state, setState] = useState(value);
    const [error, setError] = useState("");
    useEffect(() => {
        if (!someValidationRequirement(state)) {
            setError("My lovely error");
        } else {
            returnValue(state)
        }
    }, [state])
    return (
        <>
            <input value={state} onchange="{event" ==""> setState(event.target.value)} />

    )
}
`}</code></pre>
    <p><inlineCode parentName="p">{`useState`}</inlineCode>{` creates convenient state management. A getter and a setter. First const is the value, second const sets the value.`}</p>
    <p><inlineCode parentName="p">{`useEffect`}</inlineCode>{` runs our validation method on every change of `}<inlineCode parentName="p">{`state`}</inlineCode>{`. It's that second argument that ensures our function runs on changes only.`}</p>
    <p>{`You can replicate the rest of our setup with `}<inlineCode parentName="p">{`useContext`}</inlineCode>{`. You'll wind up with similar logical complexity and much less code.`}</p>
    <h2 {...{
      "id": "constate-makes-usecontext-great-"
    }}>{`Constate makes useContext great 👌`}</h2>
    <p>{`Rather than messing around with `}<inlineCode parentName="p">{`useContext`}</inlineCode>{`, I suggest using `}<a parentName="p" {...{
        "href": "https://github.com/diegohaz/constate"
      }}>{`Constate`}</a>{`. It was already my favorite library a few months ago when it was just for modern React Context.`}</p>
    <p>{`[`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=63UI2nTz1qA"
      }}>{`https://www.youtube.com/watch?v=63UI2nTz1qA`}</a>{`]`}</p>
    <p>{`With the change to hooks it became truly amaze.`}</p>
    <p>{`Something like this 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function useForm() {
    const [user, setuser] = useState("");
    const [pass, setpass] = useState("");
    const [error, setError] = useState("");
    return { user, pass, error, setUser, setPass, setError };
}
const FormContainer = createContainer(userForm);
const ContextField = ({ name }) => (
    const state = useContext(FormContainer.Context);
    return <field value={state[name]} returnvalue={state[\`set\${name}\`}>
)
function Error() {
    const { error, setError, user, pass } = useContext(FormContainer.Context);
    useEffect(() => {
        if (!someValidation(user) || !someValidation(pass)) {
            setError("A lovely form error")
        }
    }, [user, pass])
    return (
        {error}
    )
}
function Login() {
    <contextfield class="provider">
        <contextfield name="user">
        <contextfield name="pass">
        <error>
    </error></contextfield></contextfield></contextfield>
}
</field>
`}</code></pre>
    <p>{`😱`}</p>
    <p>{`Beautiful!`}</p>
    <p>{`Here's how it works:`}</p>
    <ol>
      <li parentName="ol">{`Custom hook combines all the state handling we need.`}</li>
      <li parentName="ol">{`Our hook returns its external API as an object.`}</li>
      <li parentName="ol">{`We use Constate's `}<inlineCode parentName="li">{`createContainer`}</inlineCode>{` method to wrap it in a container`}</li>
      <li parentName="ol">{`Like before, ContextField is our context-based wrapper. It takes a name and uses it to get initial value and returnValue API from state. In this case it dynamically decides which `}<inlineCode parentName="li">{`setX`}</inlineCode>{` method to use.`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`Error`}</inlineCode>{` is a new method. Because of context, we can extract form error handling into a new component. Once more `}<inlineCode parentName="li">{`useEffect`}</inlineCode>{` runs our validations when `}<inlineCode parentName="li">{`user`}</inlineCode>{` or `}<inlineCode parentName="li">{`pass`}</inlineCode>{` change.`}</li>
      <li parentName="ol">{`The `}<inlineCode parentName="li">{`Login`}</inlineCode>{` form is now our simplest component. Renders context, fields, and error.`}</li>
    </ol>
    <p>{`Delightful state management with hooks and Constate. QED`}</p>
    <p>{`:)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      